import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  TransportManagementProfileItemState,
  TransportManagementProfileItemStateModel,
} from './transport-management-profile-item.state';
import {
  TransportManagementProfileItemCreate,
  TransportManagementProfileItemInitialState,
  TransportManagementProfileItemLoad,
  TransportManagementProfileItemUpdate,
} from './transport-management-profile-item.actions';
import { TransportManagementProfileModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class TransportManagementProfileItemFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(TransportManagementProfileItemState.getProfileId);
  profile$: Observable<TransportManagementProfileItemStateModel> = this.store.select(
    TransportManagementProfileItemState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(TransportManagementProfileItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(transportPlannerProfileId: number): void {
    this.store.dispatch(new TransportManagementProfileItemLoad(transportPlannerProfileId));
  }

  createProfile(profile: Partial<TransportManagementProfileModel>, dialog: MatDialogRef<unknown>): void {
    this.store.dispatch(new TransportManagementProfileItemCreate({ dialog, profile }));
  }

  updateProfile(data: Partial<TransportManagementProfileModel>): void {
    this.store.dispatch(new TransportManagementProfileItemUpdate(data));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementProfileItemInitialState());
  }
}
